export default function Footer() {
    return (
        <footer className="relative w-full bg-black/10 backdrop-blur">
            <div className="p-4 text-center max-w-2xl mx-auto flex items-center justify-center h-full w-full">
                <div>
                    <h1 className="text-sm text-white">©2025, Made with ❤️ by <a className="underline" href="https://dreamwedding.id/" target="_blank">Dream Wedding Official</a>.</h1>
                </div>
            </div>
        </footer>
    );
}
